import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const AvailabilityPage = lazy(() => import('./pages'));

/** Schedule > Availability, next to the existing opening hours and closing dates pages, which are untouched. */
export const availabilityRoute = [
  {
    path: '/schedule/availability',
    // The API refuses the rules, calendar and capacity calls while it is off.
    Component: withFeature(
      FeatureFlagKey.RELEASE_SCHEDULE_AVAILABILITY,
      AvailabilityPage
    ),
    loader: combineLoaders(permissionsLoader),
  },
];
